goog.provide("shadow.js.shim.module$dayjs$plugin$dayOfYear");
goog.provide("module$shadow_js_shim_module$dayjs$plugin$dayOfYear");
shadow.js.shim.module$dayjs$plugin$dayOfYear = shadow.js.nativeProvides["dayjs/plugin/dayOfYear"] = require("dayjs/plugin/dayOfYear");
module$shadow_js_shim_module$dayjs$plugin$dayOfYear.default = shadow.js.shim.module$dayjs$plugin$dayOfYear;
